import { render, staticRenderFns } from "./AudienceShow.vue?vue&type=template&id=ae482e28&scoped=true&"
import script from "./AudienceShow.vue?vue&type=script&lang=js&"
export * from "./AudienceShow.vue?vue&type=script&lang=js&"
import style0 from "./AudienceShow.vue?vue&type=style&index=0&id=ae482e28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae482e28",
  null
  
)

export default component.exports